// Factories
import { BaseLogicModuleFactory } from "../../base/factories/BaseLogicModuleFactory";
/**
 * Factory class for modules in MetaOS app
 */
export class MetaOSAppLogicModuleFactory extends BaseLogicModuleFactory {
}
